export default {
  name: 'marking--statusMap',
  apiService: 'shoes',
  apiPath: '/admin/status_map',
  enums: {
    result: ['OK', 'NOTOK', 'OVER', 'SHORTFALL', 'RE_GRADING', 'CODE_NOT_FOUND', 'DIFFERENT_VENDOR_DATA',],
  }
};